import { render } from "./FeedBacks.vue?vue&type=template&id=0b126220&scoped=true"
import script from "./FeedBacks.vue?vue&type=script&lang=js"
export * from "./FeedBacks.vue?vue&type=script&lang=js"

import "./FeedBacks.vue?vue&type=style&index=0&id=0b126220&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b126220"]])

export default __exports__